import Reveal from "./Reveal";
import goldenClean from "@/assets/golden_clean.png";
import pinkClean from "@/assets/pink_clean.png";
import fallClean from "@/assets/fall_clean.png";

const SHEET_PHOTOS = {
  "formula-face-cream": {
    src: goldenClean,
    alt: "Flacone Brahma Golden PB Face Cream anti-age postbiotic technology",
  },
  "formula-face-serum": {
    src: pinkClean,
    alt: "Flacone Brahma Pink Lady Face Serum anti-age",
  },
  "formula-cleansing-oil": {
    src: fallClean,
    alt: "Flacone Brahma Fall Water Cleansing Oil 150 ml",
  },
};

const SHEETS = [
  {
    id: "formula-face-cream",
    brahma: "Brahma Golden PB",
    title: "Face Cream (50 ml)",
    subtitle: "Trattamento Rigenerante Postbiotico & Anti-Age",
    subtitleCls: "text-gold-deep",
    glow: "rgba(243, 228, 188, 0.75)",
    desc: "Trattamento viso unisex ad azione profonda giorno e notte.",
    actives: [
      {
        n: "Tecnologia Postbiotica (Drieline®)",
        d: "stimola le difese e riequilibra il microbiota cutaneo.",
      },
      {
        n: "Acido Ialuronico a 3 Pesi Molecolari",
        d: "idratazione multilivello profonda e rimpolpante.",
      },
      {
        n: "Retinil Palmitato",
        d: "derivato del retinolo che stimola il turnover cellulare e attenua le rughe.",
      },
      {
        n: "Vitamina C & Luminescina",
        d: "potente azione illuminante foto-luminescente e antimacchia.",
      },
      {
        n: "Vitamina E & Filtri UVA-UVB",
        d: "scudo antiossidante e protezione fotocutanea.",
      },
    ],
    texture: "Crema vellutata e nutriente con delicata nota floreale neutra.",
  },
  {
    id: "formula-face-serum",
    brahma: "Brahma Pink Lady",
    title: "Face Serum (30 ml)",
    subtitle: "Siero Intensivo Multiazione & Botox-Like",
    subtitleCls: "text-blush-deep",
    glow: "rgba(249, 218, 213, 0.75)",
    desc: "Siero ad azione globale per rughe d'espressione, idratazione e tono perioculare.",
    actives: [
      {
        n: "Dipeptide Diaminobutyroyl",
        d: 'peptide distensivo effetto "botox-like" per rughe mimiche.',
      },
      {
        n: "Bacillus Ferment",
        d: "biofermentato che dona sguardo fresco, compatto e luminoso.",
      },
      {
        n: "Acido Ialuronico BPM",
        d: "penetrazione rapida per idratare e distendere i tratti.",
      },
      {
        n: "Saccharide Isomerate",
        d: "idratazione biomimetica profonda che evita la pelle che tira.",
      },
      {
        n: "Estratto di Mela, Aloe Vera, Pantenolo & Niacinamide",
        d: "pool decongestionante e uniformante.",
      },
    ],
    texture: "Fluido ultra-leggero a rapido assorbimento senza residuo appiccicoso.",
  },
  {
    id: "formula-cleansing-oil",
    brahma: "Brahma Fall Water",
    title: "Cleansing Oil (150 ml)",
    subtitle: "Detersione per Affinità & Rispetto della Barriera",
    subtitleCls: "text-sage-deep",
    glow: "rgba(217, 232, 217, 0.75)",
    desc: "Olio detergente e struccante a schiuma morbida controllata per tutti i tipi di pelle.",
    actives: [
      {
        n: "Squalano Vegetale & Derivati dell'Oliva",
        d: "detersione lipidica per affinità senza residuo untuoso.",
      },
      {
        n: "Estratto di Mela",
        d: "apporto naturale di zuccheri idratanti, vitamine e antiossidanti.",
      },
      {
        n: "Pantenolo & Bisabololo",
        d: "azione lenitiva, calmante e disarrossante post-detersione.",
      },
      {
        n: "Vitamina E",
        d: "protezione dallo stress ossidativo e salvaguardia del film idrolipidico.",
      },
    ],
    texture: "Fluido idrofilo delicato, purifica a fondo mantenendo la cute morbida e setosa.",
  },
];

export const Formulation = () => (
  <section id="formulazione" className="relative overflow-hidden bg-marble py-24 lg:py-36">
    <div
      className="pointer-events-none absolute -right-24 top-0 h-96 w-96 rounded-full bg-blush/60 blur-3xl"
      aria-hidden="true"
    />
    <div
      className="pointer-events-none absolute -left-24 bottom-0 h-80 w-80 rounded-full bg-sage/50 blur-3xl"
      aria-hidden="true"
    />

    <div className="relative mx-auto max-w-7xl px-5 lg:px-10">
      <Reveal>
        <span className="text-[11px] font-medium uppercase tracking-[0.42em] text-gold-deep">
          Formulazione
        </span>
        <h2 className="mt-4 font-display text-4xl font-light leading-tight text-ink lg:text-6xl">
          Scienza postbiotica, <span className="italic text-gold-deep">efficacia delicata</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid gap-8 md:grid-cols-3">
        {SHEETS.map((s, i) => (
          <Reveal key={s.id} delay={0.08 * i} className="h-full">
            <article id={s.id} data-testid={s.id} className="relative h-full scroll-mt-24">
              <div
                className="absolute -inset-3 rounded-[2rem] opacity-40 blur-xl"
                style={{ background: s.glow }}
                aria-hidden="true"
              />
              <div className="relative flex h-full flex-col overflow-hidden rounded-3xl border border-stone-200/50 bg-white/70 p-8 shadow-[0_24px_50px_rgba(28,28,30,0.08)] backdrop-blur-md">
                <div
                  className="pointer-events-none absolute inset-0"
                  style={{
                    background: `radial-gradient(75% 45% at 50% 0%, ${s.glow} 0%, rgba(255,255,255,0) 70%)`,
                  }}
                />
                <div className="relative flex h-full flex-col">
                  <div
                    className="relative mb-6 flex justify-center"
                    data-testid={`${s.id}-photo`}
                  >
                    <div
                      className="absolute left-1/2 top-1/2 h-[92%] w-[74%] -translate-x-1/2 -translate-y-1/2 rounded-full blur-2xl"
                      style={{
                        background: `radial-gradient(60% 55% at 50% 50%, ${s.glow} 0%, rgba(255,255,255,0) 72%)`,
                      }}
                      aria-hidden="true"
                    />
                    <img
                      src={SHEET_PHOTOS[s.id].src}
                      alt={SHEET_PHOTOS[s.id].alt}
                      className="relative h-44 w-auto object-contain lg:h-52"
                    />
                    <div
                      className="absolute bottom-0.5 left-1/2 h-2.5 w-[36%] -translate-x-1/2 rounded-[50%] bg-[#1C1C1E] opacity-[0.12] blur-md"
                      aria-hidden="true"
                    />
                  </div>
                  <p className="text-[10px] uppercase tracking-[0.3em] text-ink/55">{s.brahma}</p>
                  <h3 className="mt-3 font-display text-2xl font-light text-ink lg:text-3xl">
                    {s.title}
                  </h3>
                  <p className={`mt-1 text-sm italic ${s.subtitleCls}`}>{s.subtitle}</p>
                  <p className="mt-4 text-sm font-light leading-relaxed text-smoke">{s.desc}</p>

                  <p className="mt-6 text-[10px] uppercase tracking-[0.28em] text-gold-deep">
                    Principi Attivi Chiave
                  </p>
                  <ul className="mt-3 space-y-2.5">
                    {s.actives.map((a) => (
                      <li
                        key={a.n}
                        className="flex gap-2.5 text-sm font-light leading-relaxed text-smoke"
                      >
                        <span
                          className="mt-[7px] h-1.5 w-1.5 shrink-0 rotate-45 bg-gold-grad"
                          aria-hidden="true"
                        />
                        <span>
                          <span className="font-medium text-ink">{a.n}:</span> {a.d}
                        </span>
                      </li>
                    ))}
                  </ul>

                  <p className="mt-auto pt-6 text-sm font-light italic text-ink/70">
                    <span className="mr-2 text-[10px] uppercase not-italic tracking-[0.28em] text-smoke">
                      Texture:
                    </span>
                    {s.texture}
                  </p>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
